<template>
  <div v-if="checkAddLyricsType === 'global' ||
          checkAddLyricsType === 'own'"
       class="AddLyricsPopup">
    <div v-if="checkAddLyricsType === 'global'"
         class="global">
      <h1 class="font-size-big">Dodaj piosenkę z bazy globalnej</h1>
      <LyricSearch
          :placeholder="'Wyszukaj'"
          :value="query"
          :isLoading="isLoading"
          @input="handleSearchInput"
          @search="handleSearch"
      />
      <div v-if="lyricsNotFound" class="info">
        <h2 class="font-size-middle">
          Brak szukanej piosenki. Upewnij się że piosenka znajduje się w Twojej bibliotece, jeśli nie możesz ją
          dodać.
        </h2>
      </div>
      <div class="ph-item" v-if="this.lyricsApiCollection===null">
        <div class="ph-col-12">
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
          <div class="ph-row">
            <div class="big"></div>
            <div class="big"></div>
            <div class="big"></div>
          </div>
        </div>
      </div>
      <div
          v-else-if="areLyricsVisible && lyricsApiCollection !== null && !areSearchLyricsVisible"
          class="lyrics-list">
        <div class="lyrics-row-wrapper">
          <div v-for="(lyric) in this.lyricsApiCollection.lyrics" :key="lyric.key"
               :lyric="lyric"
               class="AccessLyrics">
            <div class="title font-size-middle">
              {{ lyric.title }}
            </div>
            <SmallButton button-hover-behaviour="gold" class="edit-button" icon="pen"
                         @click="editBandLyric(lyric)">Edytuj i dodaj
            </SmallButton>
            <SmallButton v-if="!areLyricsAdded[lyric.id-1]" class="add-button"
                         button-hover-behaviour="gold" icon="plus"
                         @click="addToBandLyrics(lyric)">Dodaj
            </SmallButton>
            <img v-if="areLyricsAdded[lyric.id-1]" class="added-image"
                 src="../assets/images/button/confirmStatusBtn.svg"/>
          </div>
          <div class="infinite-scroll" ref="infiniteScroll"></div>
        </div>
        <div v-if="lyricsApiCollection != null && !areSearchLyricsVisible">
          <p class="lyrics-counter font-size-middle">{{ visibleLyricsCounter }}</p>
        </div>
        <div v-if="isLoadingNextLyricsPages" class="loader"></div>
      </div>
      <div class="lyrics-list" v-if="areSearchLyricsVisible">
        <div v-for="lyric in lyrics" :key="lyric.key"
             :lyric="lyric"
             class="AccessLyrics">
          <div class="title font-size-middle">
            {{ lyric.title }}
          </div>
          <SmallButton button-hover-behaviour="gold" class="edit-button" icon="pen"
                       @click="editBandLyric(lyric)">Edytuj i dodaj
          </SmallButton>
          <SmallButton v-if="!areLyricsAdded[lyric.id-1]" class="add-button"
                       button-hover-behaviour="gold" icon="plus"
                       @click="addToBandLyrics(lyric)">Dodaj
          </SmallButton>
          <img v-if="areLyricsAdded[lyric.id-1]" class="added-image"
               src="../assets/images/button/confirmStatusBtn.svg"/>
        </div>
      </div>
      <button class="close-button font-size-small" @click="$emit('close')">Zamknij
      </button>
    </div>
    <div v-if="checkAddLyricsType === 'own'"
         class="own">
      <button @click="$emit('close')">OK
      </button>
    </div>
  </div>
</template>

<script>

import { getLyricsService } from '@/services/lyricsService'
import LyricSearch from '@/components/LyricSearch'
import '../../node_modules/placeholder-loading/src/scss/placeholder-loading.scss'
import { createCancellable } from '@/helpers/asyncHelper'
import SmallButton from '@/components/input/SmallButton'

export default {
  name: 'AddLyricsPopup',
  components: {
    SmallButton,
    LyricSearch,
  },
  data () {
    return {
      addLyricsType: null,
      query: '',
      lyricsApiCollection: this.initializeFirstPage(1),
      pages: this.lyricsApiCollection,
      areLyricsAdded: this.lyricsApiCollection,
      lyricsNotFound: false,
      isLoading: false,
      areLyricsVisible: true,
      areSearchLyricsVisible: false,
      observer: null,
      page: 1,
      initialLoading: true,
      isLoadingNextLyricsPages: false
    }
  },
  mounted () {
    this.lyricsApiCollection = null
    this.observer = new IntersectionObserver(this.onElementObserved, {
      threshold: 0.0,
    })
  },
  computed: {
    checkAddLyricsType () {
      let addLyricsType

      addLyricsType = this.$route.query.lyricsPopupType

      return addLyricsType
    },
    visibleLyricsCounter () {
      if (this.lyricsApiCollection?.lyrics) {
        return `Wczytano ${this.lyricsApiCollection.lyrics.length}
        z ${this.lyricsApiCollection.totalItems} piosenek`
      } else {
        return ``
      }
    },
  },
  methods: {
    async getBandLyrics (page) {
      return await Promise.all([await getLyricsService().getBandLyrics(page)])
    },
    async showBandLyricsFirstPage (page, notIncreasePage) {
      this.bandLyricsApiCollection = (await this.getBandLyrics(page))[0]
      if (this.bandLyricsApiCollection === null || this.bandLyricsApiCollection.bandLyrics.length === 0) {
        this.bandLyricsNotFound = true
      } else {
        this.observeScrollElement()
        this.bandLyricsNotFound = false
      }
      this.pages = this.getPages()
      this.initialLoading = false
      if (!notIncreasePage) {
        this.page++
      }
      this.dataLoading.updatedLoading = false
      this.dataLoading.loadingOrder = 0
    },
    editBandLyric (lyric) {
      getLyricsService().addToBandLyrics(lyric).then(response => {
        this.$router.push({
          name: 'EditBandLyricPage',
          query: { id: response.id },
        })
      });
    },
    onElementObserved (entries) {
      if (entries[0].isIntersecting === true) {
        this.loadNextLyricsPages()
      }
    },
    observeScrollElement () {
      if (!this.lyricsNotFound && this.checkAddLyricsType != null &&
          this.checkAddLyricsType === 'global') {
        setTimeout(() => {
          if (this.$refs.infiniteScroll != null) {
            this.observer.observe(this.$refs.infiniteScroll)
          }
        }, 1000)
      }
    },
    addToBandLyrics (lyric) {
      getLyricsService().addToBandLyrics(lyric)
      this.areLyricsAdded[lyric.id - 1] = true
      this.$forceUpdate()
    },
    getPages () {
      if (this.lyricsApiCollection) {
        const lastPage = this.lyricsApiCollection.lastPage.page
        const pages = []

        for (let i = 0; i < lastPage; i++) {
          pages[i] = i + 1
        }

        return pages
      }
    },
    getAreLyricsAddedTable () {
      const areLyricsAdded = []

      this.lyricsApiCollection.lyrics.forEach((element) => {
        areLyricsAdded[element.id - 1] = false
      })

      return areLyricsAdded
    },
    async initializeFirstPage (page) {
      this.lyricsApiCollection = (await this.addGlobalLyrics(page))[0]
      if (this.lyricsApiCollection === null || this.lyricsApiCollection.lyrics.length === 0) {
        this.lyricsNotFound = true
      } else {
        this.observeScrollElement()
      }
      this.pages = this.getPages()
      this.areLyricsAdded = this.getAreLyricsAddedTable()
      if (this.initialLoading) {
        this.initialLoading = false
        this.page++
      }
    },
    async loadNextLyricsPages () {
      if (
          !this.initialLoading &&
          !this.lyricsNotFound &&
          !this.areSearchLyricsVisible &&
          this.pages != null &&
          this.page <= this.pages[this.pages.length - 1]
      ) {
        this.isLoadingNextLyricsPages = true
        let newData = (await this.addGlobalLyrics(this.page))[0]
        this.lyricsApiCollection.lyrics = this.lyricsApiCollection.lyrics.concat(newData.lyrics)
        this.page++
        this.isLoadingNextLyricsPages = false
      }
    },
    async addGlobalLyrics (page) {
      return await Promise.all([await getLyricsService().getGlobalLyrics(page)])
    },
    async addOwnLyrics () {
      this.lyrics = [await getLyricsService().getOwnLyrics(16)]
    },
    handleSearchInput (query) {
      this.query = query
    },
    handleSearch (query) {
      this.isLoading = true

      if (this.lyricsFetchAction) {
        this.lyricsFetchAction.cancel()
      }

      this.lyricsFetchAction = createCancellable(() => getLyricsService().searchGlobalLyrics(query))

      if (query.length !== 0) {
        this.lyricsFetchAction().then((lyrics) => {
          this.lyrics = lyrics
          this.isLoading = false
          this.areLyricsVisible = false
          this.areSearchLyricsVisible = true
          this.lyricsFetchAction = null
          this.lyricsNotFound = false
          if (this.lyrics.length === 0) {
            this.lyricsNotFound = true
          }
        })
      } else {
        this.isLoading = false
        this.lyrics = []
        this.lyricsFetchAction = null
        this.areSearchLyricsVisible = false
        this.areLyricsVisible = true
        this.lyricsNotFound = false
        this.observeScrollElement()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $grey-light;
  border: thin solid $grey-light;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $dark-text;
  border: thin solid $dark-text;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $primary;
  border: thin solid $primary;
  border-radius: 10px;
}

.global {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.AddLyricsPopup {
  z-index: 2;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 90vh;
  border: 2px solid $primary;
  border-radius: 10px;
  margin: auto;
  padding: 20px 40px 10px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: rgb(0, 0, 0);
  overflow: hidden;

  @media only screen and (width: 1024px) {
    padding-top: 0;
  }

  h1 {
    text-align: center;
    margin-bottom: 10px;
    color: $primary;

    @media only screen and (width: 1024px) {
      margin-bottom: 0;
    }
  }

  .lyrics-list {
    overflow: auto;

    .lyrics-row-wrapper {
      position: relative;

      .infinite-scroll {
        pointer-events: none;
        z-index: -100;
        height: 200px;
        width: 100%;
        position: absolute;
        bottom: 0;
      }
    }

    .lyrics-counter {
      text-align: center;
    }

    .AccessLyrics {
      display: grid;
      grid-template-columns: 3fr 1fr 1fr;

      .title {
        color: $dark-text;
        margin: 10px;
      }

      .edit-button {
        position: relative;
        margin: 10px;
        margin-top: auto;
        margin-bottom: auto;
        padding: 0;
        background-color: $dark-text;
        width: 100px;
        height: 20px;
        border-color: $dark-text;

        @media only screen and (max-width: 1280px) {
          background-color: transparent;
        }
      }

      .add-button {
        position: relative;
        margin: 10px;
        margin-top: auto;
        margin-bottom: auto;
        padding: 0;
        background-color: $dark-text;
        border-color: $dark-text;
        width: 100px;
        height: 20px;

        @media only screen and (max-width: 1280px) {
          background-color: transparent;
        }
      }

      .added-image {
        margin: 10px;
        margin-top: auto;
        margin-bottom: auto;
        border: solid 1px $primary;
        border-radius: 5px;
        width: 100px;
        height: 20px;
      }
    }

    .AccessLyrics:hover {
      background-color: $list-row-focus;

      .title {
        color: white;
      }

      .edit-button {
        border-color: $primary;
      }

      .add-button {
        border-color: $primary;
      }
    }
  }

  .loader {
    width: 20px;
    margin: 1px;
    font-size: 10px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    text-indent: -9999em;
    border-top: 0.5em solid $primary;
    border-right: 0.5em solid $primary;
    border-bottom: 0.5em solid $primary;
    border-left: 0.5em solid #ffffff;
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 0.8s infinite linear;
  }

  .loader,
  .loader:after {
    border-radius: 100%;
    width: 5em;
    height: 5em;
  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .info {
    text-align: center;

    p {
      margin-top: 4px;
      margin-bottom: 0;
      color: darken(white, 20);
    }
  }

  .close-button {
    margin-top: 10px;
    background-color: black;
    border: solid 1px $primary;
    border-radius: 5px;
    color: $dark-text;
    width: 100%;
    min-height: 20px;
    cursor: pointer;
  }
}

@media only screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .AddLyricsPopup {
    width: 100%;
    padding: 10px;

    h1 {
      margin-top: 0;
    }

    .lyrics-list {
      .AccessLyrics {
        grid-template-columns: 2fr 1fr 1fr;

        .title {
          margin: 5px;
          margin-right: 0;
        }

        .edit-button {
          margin: 5px;
          margin-top: auto;
          margin-bottom: auto;
          min-width: 0;
          width: 55px;
          max-height: 60px;
          height: 50px;
        }

        .add-button {
          margin: 5px;
          margin-top: auto;
          margin-bottom: auto;
          min-width: 0;
          width: 50px;
          max-height: 60px;
          height: 50px;
        }

        .added-image {
          border: none;
          margin: 5px;
          margin-top: auto;
          margin-bottom: auto;
          margin-left: 30px;
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}

@media only screen and (max-width: $phone-max-width) {
  .AddLyricsPopup {
    width: 100%;
    padding: 10px;

    h1 {
      margin-top: 0;
    }

    .lyrics-list {
      .AccessLyrics {
        grid-template-columns: 2fr 1fr 1fr;

        .title {
          margin: 5px;
          margin-right: 0;
        }

        .edit-button {
          margin: 5px;
          margin-top: auto;
          margin-bottom: auto;
          min-width: 0;
          width: 55px;
          max-height: 60px;
          height: 50px;
        }

        .add-button {
          margin: 5px;
          margin-top: auto;
          margin-bottom: auto;
          min-width: 0;
          width: 50px;
          max-height: 60px;
          height: 50px;
        }

        .added-image {
          border: none;
          margin: 5px;
          margin-top: auto;
          margin-bottom: auto;
          margin-left: 30px;
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}

.ph-item {
  direction: ltr;
  position: relative;
  padding: 0;
  overflow: hidden;
  margin-bottom: 30px;
  background-color: transparent;
  border: none;
  border-radius: 0;

  &::before {
    display: none;
  }

  .ph-row {
    display: grid;
    grid-template-columns: 3fr 1fr 1fr;
    margin: 0 4% 0 0;

    @media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
      grid-template-columns: 1fr;
    }
    @media screen and (max-width: $phone-max-width) {
      grid-template-columns: 1fr;
    }

    .big:nth-child(1) {
      width: 80%;

      @media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
        width: 100%;
      }
      @media screen and (max-width: $phone-max-width) {
        width: 90%;
      }
    }

    .big:nth-child(2) {
      width: 100px;
      margin-left: auto;
      margin-right: auto;

      @media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
        display: none;
      }
      @media screen and (max-width: $phone-max-width) {
        display: none;
      }
    }

    .big:nth-child(3) {
      width: 100px;
      margin-left: auto;
      margin-right: auto;

      @media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
        display: none;
      }
      @media screen and (max-width: $phone-max-width) {
        display: none;
      }
    }
  }

  .ph-col-12 {
    margin: 0;
    padding: 0;
    overflow-y: scroll;
  }

  .big {
    height: 22px;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
    background-color: #727271;
    margin: 9px 0;

    &::before {
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 50%;
      width: 500%;
      margin-left: -250%;
      -webkit-animation: phAnimation 0.8s linear infinite;
      animation: phAnimation 0.8s linear infinite;
      background: linear-gradient(
              to right,
              rgba(255, 255, 255, 0) 46%,
              rgba(255, 255, 255, 0.35) 50%,
              rgba(255, 255, 255, 0) 54%) 50% 50%;
      z-index: 0;
    }

    @media screen and (max-width: 600px) {
      height: 45px;
      margin: 8px;
    }
  }

  .ph-item > * {
    padding: 0;
  }
}

@media only screen and (min-height: 1000px) {
  .AddLyricsPopup {
    .lyrics-list {
      height: 67vh;
    }
  }
}
</style>
